import type { RouteRecordRaw } from "vue-router";

export const personaRoutes: RouteRecordRaw[] = [
  // AI Personas
  {
    path: "/ai/personas",
    name: "ai_persona-index",
    component: () => import("./personas/PersonaListPage.vue"),
    meta: {
      title: "tools_meta.ai_personas_prefix",
    },
  },
  {
    path: "/ai/personas/:id/chat/:conversationId",
    name: "ai_persona-chat-show",
    component: () => import("./personas/[id]/chat/PersonaChatPage.vue"),
    meta: {
      title: "tools_meta.ai_personas_prefix",
    },
  },
  {
    path: "/ai/personas/history",
    name: "ai-persona-history",
    component: () => import("./personas/history.vue"),
    meta: {
      title: "tools_meta.ai_personas_prefix",
    },
  },
  {
    path: "/ai/personas/info",
    name: "ai_persona-info",
    component: () => import("./personas/info.vue"),
    meta: {
      title: "tools_meta.ai_personas_prefix",
    },
  },
  {
    path: "/ai/personas/new",
    name: "ai-persona-new",
    component: () => import("./personas/index/new.vue"),
    meta: {
      title: "tools_meta.ai_personas_prefix",
    },
  },
];
